import { FC, ReactNode } from 'react';

import styles from './styles.css';

interface IConsultationFormControls {
  controls: ReactNode;
}
export const ConsultationFormControls: FC<IConsultationFormControls> = ({ controls }) => {
  return <div className={styles['controls']}>{controls}</div>;
};
